import api from '../../api'
import * as types from '../../types'

export default {
  state: {
    applyDate: '',
    balancedSum: '',
    loanAmount: '',
    bankAccountInfo: '',
    balancedPrincipal: '',
    balancedInterest: '',
    balancedFee: '',
    shouldPenalty: '',
    canAdvancedRepay: ''
  },
  getters: {
    [types.GET_PREPAYMENT_DETAIL] (state) {
      return {
        applyDate: state.applyDate,
        balancedSum: state.balancedSum,
        loanAmount: state.loanAmount,
        bankAccountInfo: state.bankAccountInfo,
        balancedPrincipal: state.balancedPrincipal,
        balancedInterest: state.balancedInterest,
        balancedFee: state.balancedFee,
        shouldPenalty: state.shouldPenalty,
        canAdvancedRepay: state.canAdvancedRepay
      }
    }
  },
  actions: {
    [types.GET_PREPAYMENT_DATA]: ({ commit }, params) => api.getRepaymentInfo(params),
    [types.ADVANCE_CONFIRM]: ({ commit }, params) => api.advanceConfirm(params),
    [types.GET_PART_PREPAYMENT_MONEY]: ({ commit }, params) => api.getPartPrepaymentMoney(params)
  },
  mutations: {
    [types.SET_PREPAYMENT_DETAIL] (state, data) {
      state.applyDate = data.applyDate
      state.balancedSum = data.balancedSum
      state.loanAmount = data.loanAmount
      state.bankAccountInfo = data.bankAccountInfo
      state.balancedPrincipal = data.balancedPrincipal
      state.balancedInterest = data.balancedInterest
      state.balancedFee = data.balancedFee
      state.shouldPenalty = data.shouldPenalty
      state.canAdvancedRepay = data.canAdvancedRepay
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/personalCenter/prepayment.js